module.exports = __webpack_public_path__ + "static/assets/7fd99d586ed1118a165b5cdc9cfed545.svg";